<template>
    <!-- 左侧导航 -->
    <ul class="left-menu  ">
        <li :class="{active:menuNum==1}" @click="menuNum=1">
            <p class="posi-relative">
                <img class="icon" src="../../assets/img/jgkhsh.png">
                组合分析
                <img class="rt_jt posi-absolute" src="../../assets/img/rt_jt.png">
            </p>
            <ul class="childMenu">
                <li class="active" @click="$router.push({path:'/performance'})">
                    <p>仓位绩效分析</p>
                </li>  
            </ul>
        </li> 
         <li :class="{active:menuNum==3}"  @click="menuNum=3">
            <p class="posi-relative">
                <img class="icon" src="../../assets/img/jgkhsh.png">
                基础分析
                <img class="rt_jt posi-absolute" src="../../assets/img/rt_jt.png">
            </p>
            <ul class="childMenu">
                <li @click="">
                    <p>
                        持仓查询
                    </p>
                </li> 
            </ul>
        </li>
        <!-- <li class="menuTitle" v-for="(item,k) in menuInfo" :key='k'>
            <p>
                <img src="../../assets/img/jgkhsh.png">
                {{item.menuName}}  
            </p>
            <ul class="childMenu">
                <li v-for="(item_sub,k_sub) in item.childMenus" :key='k_sub' :class="{active:'/'+menuUrl==item_sub.menuPath}"
                    @click="menuClick(item_sub)">
                    <p>
                        <img src="../../assets/img/jgkhsh.png">
                        {{item_sub.menuName}}
                    </p>
                </li> 
            </ul>
        </li> -->
    </ul>
</template>
<script>
    export default {
        mounted(){
            this.menuInfo = this.$store.state.menuInfo;
        },
        props:['','menuUrl'],
        data(){
            return{
                menuInfo:'',
                menuNum:'1'
            }
        },
        methods:{
            menuClick(item){
                this.$router.push({path:item.menuPath});
            }
        }
    }
</script>
<style lang="less" scoped>
    .left-menu{
        height:100%;
        width:13rem;
        background: #fff ;
        //公用
        li{
            transition: all .2s;
            cursor: pointer;
            >p{
                transition: all .2s;
                height:2.5rem;
                line-height: 2.5rem;
                padding-left:1rem;
                display: flex;
            } 
        }
        >li{
            min-height:2.5rem;
            max-height:2.5rem;
            overflow: hidden;
            transition: max-height .001s linear;  //收缩时不显示过度
            >p{
                img.icon{
                    width:.8rem;
                    height:.8rem;
                    margin:.65rem .5rem 0 0;
                }
                height: 2.5rem;
                img.rt_jt{
                    top:1.1rem;
                    right: .6rem;
                    width:.3rem;
                    height:.5rem;
                }
            }
            // 子菜单
            >ul{
                margin-left: 1.2rem;
                li{
                    p{
                        height:auto;
                        line-height: 1.5;
                        padding:.75rem 0  0 1.2rem;
                    }
                }
                li:hover,li.active{
                    background: #f8f8f8;
                    >p{
                        
                        color: #1866FF;
                    }
                }
            }
        }
        >li:hover,>li.active{
            >p{
                background: #1866FF !important;
                color:#fff;
            }
        }
        >li.active{
            max-height:300px;
            transition: max-height .5s linear;   
        }
        >li + li{
            margin-top:.5rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/leftCpt.vue